import { MyTreeNode } from "./TreeviewObject";
import { MatTreeNestedDataSource } from "@angular/material";
import { NestedTreeControl } from "@angular/cdk/tree";

export class Detail {
    Actions:Action[];
    Captcha?: string;
    CreateDate:Date;
    CreatedBy:string;
    DocTitle:string;
    DocSubtitle:string;
    DocumentId:string;
    DocumentType:string;
    DocumentTypeCode:string;
    FormCurrentScore: number;
    FormMaxScore: number;
    FormProperties:FormProperties[];
    Groups:DetailPropertyGroup[];
    IsAutoLoad: boolean;
    UpdatedDate:Date;
    UpdatedBy:string;
    Sections:DetailSection[];
    StateDisplayType:string;
    Properties:DetailProperty[];
    ViewAs: string;
}

export class DetailProperty{
    ChildPropertyName:string;
    PropertyId:string;
    PropertyName:string;
    PropertyDisplay:string;
    PropertyValue:string;
    PropertyValueDisplay:string;
    PropertyValueArray:string[];
    PropertyValueDisplayArray: string[];
    PropertyOrder:number;
    PropertyFormControlType:string;
    PropertyGroupId:string;
    PropertyDisplayType:string;
    PropertyDisplayFormat:string;
    PropertyIsEditable:boolean;
    ParentPropertyName:string;
    ParentPropertyValue: string;
    PropertyClientIsHidden: boolean;
    PropertyIsHidden:boolean;
    PropertyFixedFileUrl:any;
    PropertyShowHierarchy:boolean;
    PropertySubDisplay: string;
    PropertyLoadHierarchy:boolean;
    PropertyValidation:PropertyValidation;
    ReportFieldSize:string;
    TriggersWorkflow:string;
    PropertyOriginalValueSelection:ValueSelection[];
    PropertyValueSelection:ValueSelection[];
    PropertyInvalidFormat:boolean;
    IsAutoComplete:boolean;
    IsDropdownOpen: boolean;
    isDisabled: boolean;
    HasHelp:boolean;
    HelpId:string;
    treeControl: NestedTreeControl<MyTreeNode>;
    treeDataSource: MatTreeNestedDataSource<MyTreeNode>;
}

export class FormProperties {
    IsEditable: boolean;
    IsMandatory: boolean;
    HasBaseRemarks: boolean;
    PropertyDisplay: string;
    PropertyGroupId: string;
    PropertyId: string;
    PropertyMaxScore: number;
    PropertyName: string;
    PropertyFormattedName: string;
    PropertyOptionGroups: OptionsGroup[];
    PropertyOptions: Options[];
    PropertyOrder: number;
    PropertyRemarks: string;
    PropertyBaseRemarks: string;
    PropertyScore: number;
    PropertySubDisplay: string;
    PropertyType: string;
    PropertyValue: string;
    PropertyOptionRows: any;
    TransportValueSelection: TransportValueSelection[];
}

export class TransportValueSelection {
    OptionValue : string;
    GroupId: string;
}

export class OptionsGroup {
    GroupDisplay: string;
    GroupId: string;
    GroupOrder: number;
    GroupScore: number;
}

export class Options {
    OptionDisplay: string;
    OptionGroup: string;
    OptionOrder: number;
    OptionRequiresRemarks: boolean;
    OptionScore: number;
    OptionValue: string;
    OptionIsSelected: boolean;
    OptionRemarksMandatory: boolean;
}

export class PropertyValidation {
    Condition :string;
    FormatValidationMessage :string;
    InvalidFormat: boolean;
    IsMandatory: boolean;
    NoMatch:boolean;
    PropertyFormat: string;
    PropertyId: string;
    PropertyLength: number;
    PropertyValidationId:string;
    MinMaxType: string;
    MaxValue: string;
    MinValue: string;
}

export class ValueSelection {
    IsSelected:boolean;
    SelectionValue:string;
    SelectionMapValue:string;
    SelectionDisplay:string;
    GroupBy:string;
    HasChild: boolean;
}

export class DetailPropertyGroup{
    InitialLoad: boolean;
    IsExpanded: boolean;
    IsExport: boolean;
    GroupActions:Action[];
    GroupFormat:string;
    GroupId:string;
    GroupName:string;
    GroupDisplay:string;
    GroupOrder:number;
    GroupType:string;
    HasHelp:boolean;
    HelpId:string;
    RelatedDocument:string;
    SummaryName:string;
    SectionId:string;
    ShowSummary:boolean;
    ShowSummarySettings:boolean;
    SummaryCollapsed:boolean;
    TriggerFocus: boolean;
}

export class DetailSection{
    SectionId:string;
    SectionName:string;
    SectionDisplay:string;
    SectionOrder:number;
    HasHelp: boolean;
    HelpId: string;
    ValidationStatus:string;
}

export class GroupAction {
    Actions: Action[];
    GroupDisplay: string;
    GroupId: string;
    GroupName: string;
    GroupOrder: number;
    GroupType: string;
}

export class Action{
    ActionId:string;
    ActionName:string;
    ActionDisplay:string;
    ActionCommand:string;
    ActionOrder:number;
    DisplayOnGroup:string;
    IsHidden: boolean;
    SubActions:Action[];
    TriggersPrompt:boolean;
    TriggersValidation:boolean;
    TriggersSubAction:string;
    PromptType:string;
    PromptMessage:string;
}


export class InfoCard{
    DocumentMasterId:string;
    DocumentInstanceId:string;
    InfoCardHeaderDisplay:string;
    InfoCardName:string;
    InfoCardType:string;
    InfoCardLayout:string;
    Sections: InfoCardSection[];
    HasHelp:boolean;
    HelpId:string;
}

export class InfoCardSection{
    SectionHeaderFormat:string;
    SectionHeaderDisplayFormat:string;
    SectionHeaderValue:string;
    SectionContentFormat:string;
    SectionContentDisplayFormat:string;
    SectionContentValue:string;
}

export class AttachmentSummary{
    AttachmentId:string;
    AttachmentName:string;
    AttachmentSizeInBytes:number;
    AttachmentUrl:any;
}

export class CombinationProperty {
    combinationId: string;
    properties: DetailProperty[];
    columnWidth: any[];
    IsInputLabel:boolean;
}